import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { useFetchSiteControllerSetting } from "../model";
import { SettingsSiteControllerPresenter } from "./presenter";

type Props = {
	hotelID: string;
};

export const SettingsSiteControllerContainer = memo(({ hotelID }: Props) => {
	const { data } = useFetchSiteControllerSetting({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <SettingsSiteControllerPresenter data={data} />;
});

SettingsSiteControllerContainer.displayName = "SettingsSiteControllerContainer";
